import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import PageLayout from "../PageLayout";
import Btn from "../../ui/Btn";

import appStore from "../../storage/AppStore";
import clubStore from "../../storage/ClubStore";
import adminStore from "../../storage/AdminStore";
import systemStore from "../../storage/SystemStore";

const Agreements = ({ type, basePath }) => {
  const navigate = useNavigate();

  const isAdmin = !!appStore.user?.is_admin;
  const isManager = !!clubStore.club?.is_manager;

  const store = basePath === '/admin' ? adminStore : clubStore;
  const agreements = (store.agreements || []).filter(Boolean);

  const loadAgreements = () => {
    if (!type) return;

    if (basePath === '/admin') {
      adminStore.getAgreements({ type });
    } else if (basePath === '/manager') {
      clubStore.getAgreements({
        type,
        company_id: clubStore.club?.id,
      });
    }
  };

  useEffect(() => {
    loadAgreements();
  }, [type, isAdmin, isManager, clubStore.club?.id]);

  const handleNew = () => {
    navigate(`${basePath}/edit_agreement/0`);
  };

  const handleEdit = (agreement) => {
    navigate(`${basePath}/edit_agreement/${agreement.id}`);
  };

  const handleDelete = (agreement) => {
    if (!window.confirm(appStore.tr.are_you_sure_delete)) return;

    store.deleteAgreement(agreement.id)
  };

  const handleSetActive = (agreement) => {
    store
      .setActiveAgreement(agreement.id)
      .then(() => {
        systemStore.setSuccess(appStore.tr.successfully_saved);
        loadAgreements();
      })
      .catch((error) => {
        systemStore.setError(
          appStore.tr[error?.message] || error?.message || "Error"
        );
      });
  };

  return (
    <PageLayout
      header={
        <div className="flex justify-content-between align-items-center w-full">
          <div className="flex col">
            <h3 className="m-0">{appStore.tr.agreements}</h3>
          </div>

          <div className="flex col justify-content-end">
            <Btn
              icon="pi pi-plus"
              severity="success"
              onClick={handleNew}
            />
          </div>
        </div>
      }
    >
      <div className="col-12">
        {agreements.length === 0 ? (
          <div className="game-card agreement-empty">
            {appStore.tr.not_found}
          </div>
        ) : (
          <div className="agreements-list">
            {agreements.map((agreement) => (
              <div key={agreement.id} className="game-page agreement-row mb-2">
                <div className="agreement-row-main">
                  <div className="agreement-row-title">
                    <strong>{agreement.title}</strong>
                  </div>

                  <div className="agreement-row-meta">
                    <span>{appStore.tr.version}: </span><strong>{agreement.version}</strong>
                  </div>

                  <div className="game-badges mt-2 mb-2">
                    {agreement.is_active ? (
                      <span className="badge badge-success">
                        {appStore.tr.is_active}
                      </span>
                    ) : (
                      <span className="badge badge-draft">
                        {appStore.tr.inactive}
                      </span>
                    )}
                  </div>
                </div>

                <div className="agreement-row-actions">
                  <Btn
                    icon="pi pi-pencil"
                    severity="info"
                    label={appStore.tr.edit}
                    onClick={() => handleEdit(agreement)}
                    className={"mr-2 mb-2"}
                  />

                  {!agreement.is_active && (
                    <Btn
                      icon="pi pi-check-circle"
                      severity="success"
                      label={appStore.tr.set_active}
                      onClick={() => handleSetActive(agreement)}
                      className={"mr-2 mb-2"}
                    />
                  )}

                  <Btn
                    icon="pi pi-trash"
                    severity="danger"
                    label={appStore.tr.delete}
                    onClick={() => handleDelete(agreement)}
                    className={"mr-2 mb-2"}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default observer(Agreements);